import $ from 'jquery'
import stockListTemplate from 'templates/assisted-sale/stock-list.pug'
import feedbackErrorsTemplate from 'templates/feedback-errors.pug'

import Modal from 'garden/src/js/components/modal'
import emitter from 'garden/src/js/utils/emitter'

import BaseComponent from 'scripts/components/base-component'
import componentLoader from 'scripts/component-loader'
import { showSpinner, hideSpinner } from 'scripts/utils/spinner'

const DEFAULTS = {
  messages: {
    fetchError: ['O estoque não foi encontrado, tente novamente.']
  }
}

class Stock extends BaseComponent {
  static componentName = 'stock'

  static DOMEvents = {
    click: 'onElementClick'
  }

  constructor ($element, options = {}) {
    super($element)

    this.options = $.extend({}, DEFAULTS, options)
    this.components = {}
  }

  init () {
    this.setEndpoint()
  }

  setEndpoint () {
    const { lm, storeSlug } = this.options

    this.endpoint = `/hybris/stock/${lm}/${storeSlug}/real-time`
  }

  onElementClick () {
    this.fetchStoreStocks()
  }

  fetchStoreStocks () {
    showSpinner()

    $.get(this.endpoint)
      .done(this.onFetchStoreStocksSuccess.bind(this))
      .fail(this.onFetchStoreStocksFailure.bind(this))
      .always(hideSpinner)
  }

  onFetchStoreStocksSuccess (response) {
    this.unsetModal()
    this.setModal(response)
  }

  onFetchStoreStocksFailure ({ responseJSON }) {
    let errors

    if (responseJSON && responseJSON.errors) {
      errors = responseJSON.errors
    }

    emitter.emit('stickyFeedback:error', {
      title: 'Ops! Ocorreram os seguintes erros:',
      content: feedbackErrorsTemplate(
        { errors: errors || this.options.messages.fetchError }
      )
    })
  }

  unsetModal () {
    if (this.components.$modal) {
      this.components.$modal.destroy()
    }
  }

  setModal (data) {
    this.components.$modal =
      $(stockListTemplate(data))
        .modal()
        .data('modal')

    this.setModalComponents()
    this.showModal()
  }

  setModalComponents () {
    const { $content } = this.components.$modal

    componentLoader($content.find('[data-component]'))
  }

  showModal () {
    this.components.$modal.show()
  }
}

export default ($el) => new Stock($el, $el.data()).init()

export { Stock as Component }
